import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { getWidth, Flex } from '../Flex';
import { Number } from '../Statistic/Statistic.styles';

export const width = (props) => (props.width ? { width: getWidth(props.width) } : null);
const dimmed = (props) => (props.dimmed ? { opacity: 0.5 } : null);

const wideCell = 280;

export const KPICellBase = styled.div`
    padding: 8px 8px 8px 16px;

    display: inline-block;
    width: 100%;
    ${dimmed};
    color: white;
    min-height: 62px;
`;

export const DeltaCell = styled.div`
    border-radius: 3px;
    background-color: ${(p) => (p.delta >= 0 || p.delta == null ? p.theme.color.green : p.theme.color.red)};
    color: ${(p) => p.theme.color.white};
    cursor: pointer;
    min-width: 46px;
    padding: 0 5px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: ${(p) => p.theme.breakpoint.desktopLarge}px) {
        min-width: 38px;

        height: 20px;
    }
`;

export const BenchmarkCell = styled.div`
    margin-right: 10px;
`;

export const Content = styled(Flex)`
    white-space: nowrap;
    flex-wrap: wrap;
`;

export const ActualWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
`;

export const TargetCell = styled.div`
    opacity: 0.5;
`;

export const TargetWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: space-between;
    ${({ numOfColumns }) => css`
        @media (max-width: ${numOfColumns * wideCell}px) {
            flex: 0 0 100%;
            order: 2;
        }
    `}
`;

export const DeltaTrendWrapper = styled.div`
    align-items: center;
    display: flex;
    @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
        flex: 0 0 100%;
        order: 3;
    }
`;

export const TargetNumber = styled(Number)`
    ${({ numOfColumns, theme }) => css`
        @media (max-width: ${numOfColumns * wideCell}px) {
            line-height: 18px;
            font-size: ${theme.fontSize.medium};
        }
    `}
    @media (max-width: ${(p) => p.theme.breakpoint.desktopLarge}px) {
        line-height: 16px;
        font-size: ${(p) => p.theme.fontSize.small};
    }
`;

export const TrendWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 5px;
`;

export const DataProblemsContainer = styled.div`
    position: absolute;
    right: 8px;
    bottom: 8px;
`;
export const LeftPadding = styled.span`
    padding-left: 5px;
`;
